import { ApplicationContextService } from "projects/borrower-app/src/app/services/application-context.service";
import { Option } from "../../option.model";
import { IProvideOptions } from "./options-provider.interface";
import { Injectable, OnDestroy } from "@angular/core";
import { Observable, Subscription, map } from "rxjs";

@Injectable()
export class LoanPurposeOptionsProvider implements IProvideOptions, OnDestroy {

  private _appContextSubscription: Subscription;

  constructor(private readonly _applicationContextService: ApplicationContextService) {
  }

  getOptions(): Observable<Option[]> {
    return this._applicationContextService.context.pipe(map(context => {
      return context.globalConfig.loanPurpose.map(lp => {

        let svgName = '';

        if (lp.loanPurposeName?.toLowerCase()?.includes("purchase")) {
          svgName = 'duotone-home';
        } else if (lp.loanPurposeName?.toLowerCase()?.includes("refinance")) {
          svgName = "duotone-dollar";
        } else if (lp.loanPurposeName?.toLowerCase()?.includes("construct")) {
          svgName = "duotone-tools";
        } else {
          svgName = "stockholm-bank";
        }
        const result = new Option(lp.loanPurposeName, lp.loanPurposeName, "", lp.mortgageLoanPurpose || "", svgName, "");
        // Tag with OPTION_LABEL_DEFAULTS key so the three-tier `getOptionLabel`
        // resolver can surface our Spanish defaults when admin hasn't set _i18n.
        if (lp.mortgageLoanPurpose) {
          result._defaultsKey = `loanPurpose.${lp.mortgageLoanPurpose}`;
        }
        return result;
      })
    }))
  }

  ngOnDestroy() {
    this._appContextSubscription?.unsubscribe();
  }
}
